import {AuthBasedGuard} from './auth-based-guard';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/throw';

@Injectable()
export class CanActivateViaAuthGuard extends AuthBasedGuard implements CanActivate {

  /**
   * Get user from the store or fetch it from the API and check if is logged to authorize the route
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<boolean> | Promise<boolean> | boolean}
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|Promise<boolean>|boolean {
    if (this.isLogged) {
      return true;
    } else {
      return this.authService.getCurrentUser().map(user => {
          if (user && user.id > 0) {
            this.userActions.loginUser(user);
            this.userService.keepSessionAlive();
            this.angulartics2GoogleAnalytics.setUsername(user.login);
            return true;
          } else {
            this.authService.redirectUrl = state.url;
            this.router.navigate(['/login']);
            return false;
          }
        }).catch(() => {
          this.authService.redirectUrl = state.url;
          this.router.navigate(['/login']);
          return Observable.of(false);
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/routing/auth-guard.ts